
import { Fragment } from 'react';
import { useSelector } from 'react-redux';
import './App.scss';
import NavMenu from './components/NavMenu/Navmenu';
import ToDoWrapper from './components/ToDos/ToDoWrapper';

function App() {
    const items = useSelector(state => state.todos.list);

    return (
        <Fragment>
            <NavMenu items={items} />
            <ToDoWrapper items={items} />
            <svg id="svg-icons-list">
                <defs>
                    <g id="app-icon-calendar">
                        <svg
                            width="20px"
                            height="20px"
                            viewBox="0 0 20 20"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                        >
                            <title>icone mockup-05</title>
                            <g
                                id="Symbols"
                                stroke="none"
                                strokeWidth="1"
                                fillRule="evenodd"
                            >
                                <g
                                    id="Icon-/-Sidebar-/-passive-/-calendar"
                                    fillRule="nonzero"
                                >
                                    <g id="icone-mockup-05">
                                        <path
                                            d="M18,0 C19.104,0 20,0.896 20,2 L20,18 C20,19.104 19.104,20 18,20 L2,20 C0.896,20 0,19.104 0,18 L0,2 C0,0.896 0.896,0 2,0 L18,0 Z M4.852,13.422 C4.10862473,13.422 3.506,14.0246247 3.506,14.768 C3.506,15.5113753 4.10862473,16.114 4.852,16.114 C5.59537527,16.114 6.198,15.5113753 6.198,14.768 C6.198,14.0246247 5.59537527,13.422 4.852,13.422 Z M10,13.422 C9.25662473,13.422 8.654,14.0246247 8.654,14.768 C8.654,15.5113753 9.25662473,16.114 10,16.114 C10.7433753,16.114 11.346,15.5113753 11.346,14.768 C11.346,14.0246247 10.7433753,13.422 10,13.422 Z M15.148,13.422 C14.4046247,13.422 13.802,14.0246247 13.802,14.768 C13.802,15.5113753 14.4046247,16.114 15.148,16.114 C15.8913753,16.114 16.494,15.5113753 16.494,14.768 C16.494,14.0246247 15.8913753,13.422 15.148,13.422 Z M4.852,8.232 C4.10862473,8.232 3.506,8.83462473 3.506,9.578 C3.506,10.3213753 4.10862473,10.924 4.852,10.924 C5.59537527,10.924 6.198,10.3213753 6.198,9.578 C6.198,8.83462473 5.59537527,8.232 4.852,8.232 Z M10,8.232 C9.25662473,8.232 8.654,8.83462473 8.654,9.578 C8.654,10.3213753 9.25662473,10.924 10,10.924 C10.7433753,10.924 11.346,10.3213753 11.346,9.578 C11.346,8.83462473 10.7433753,8.232 10,8.232 Z M15.148,8.232 C14.4046247,8.232 13.802,8.83462473 13.802,9.578 C13.802,10.3213753 14.4046247,10.924 15.148,10.924 C15.8913753,10.924 16.494,10.3213753 16.494,9.578 C16.494,8.83462473 15.8913753,8.232 15.148,8.232 Z"
                                            id="Combined-Shape"
                                        ></path>
                                    </g>
                                </g>
                            </g>
                        </svg>
                    </g>
                    <g id="app-icon-chart">
                        <svg
                            width="20px"
                            height="20px"
                            viewBox="0 0 20 20"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                        >
                            <title>icone mockup-07</title>
                            <g
                                id="Symbols"
                                stroke="none"
                                strokeWidth="1"
                                fillRule="evenodd"
                            >
                                <g
                                    id="Icon-/-Sidebar-/-passive-/-charts"
                                    fillRule="nonzero"
                                >
                                    <g id="icone-mockup-07">
                                        <path
                                            d="M10,10 L20,10 C20,15.486 15.486,20 10,20 C4.514,20 0,15.486 0,10 C0,4.514 4.514,0 10,0 L10,10 Z"
                                            id="Path"
                                        ></path>
                                    </g>
                                </g>
                            </g>
                        </svg>
                    </g>
                    <g id="app-icon-dashboard">
                        <svg
                            width="20px"
                            height="20px"
                            viewBox="0 0 20 20"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                        >
                            <title>icone mockup-04</title>
                            <g
                                id="Symbols"
                                stroke="none"
                                strokeWidth="1"
                                fillRule="evenodd"
                            >
                                <g
                                    id="Icon-/-Sidebar-/-passive-/-dashboard"
                                    fillRule="nonzero"
                                >
                                    <g
                                        id="icone-mockup-04"
                                        transform="translate(-0.000000, -0.000000)"
                                    >
                                        <path
                                            d="M6.426,8.426 L2,8.426 C0.896,8.426 -3.46389584e-14,7.53 -3.46389584e-14,6.426 L-3.46389584e-14,2 C-3.46389584e-14,0.896 0.896,-3.46389584e-14 2,-3.46389584e-14 L6.426,-3.46389584e-14 C7.53,-3.46389584e-14 8.426,0.896 8.426,2 L8.426,6.426 C8.426,7.53 7.53,8.426 6.426,8.426 Z"
                                            id="Path"
                                        ></path>
                                        <path
                                            d="M6.426,20 L2,20 C0.896,20 7.90478794e-14,19.104 7.90478794e-14,18 L7.90478794e-14,13.574 C7.90478794e-14,12.47 0.896,11.574 2,11.574 L6.426,11.574 C7.53,11.574 8.426,12.47 8.426,13.574 L8.426,18 C8.426,19.104 7.53,20 6.426,20 Z"
                                            id="Path"
                                        ></path>
                                        <path
                                            d="M18,20 L13.574,20 C12.47,20 11.574,19.104 11.574,18 L11.574,13.574 C11.574,12.47 12.47,11.574 13.574,11.574 L18,11.574 C19.104,11.574 20,12.47 20,13.574 L20,18 C20,19.104 19.104,20 18,20 Z"
                                            id="Path"
                                        ></path>
                                        <path
                                            d="M18,8.426 L13.574,8.426 C12.47,8.426 11.574,7.53 11.574,6.426 L11.574,2 C11.574,0.896 12.47,-3.46389584e-14 13.574,-3.46389584e-14 L18,-3.46389584e-14 C19.104,-3.46389584e-14 20,0.896 20,2 L20,6.426 C20,7.53 19.104,8.426 18,8.426 Z"
                                            id="Path"
                                        ></path>
                                    </g>
                                </g>
                            </g>
                        </svg>
                    </g>
                    <g id="app-icon-settings">
                        <svg
                            width="20px"
                            height="20px"
                            viewBox="0 0 20 20"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                        >
                            <title>Fill 1</title>
                            <g
                                id="Symbols"
                                stroke="none"
                                strokeWidth="1"
                                fillRule="evenodd"
                            >
                                <g id="Icon-/-Sidebar-/-passive-/-settings">
                                    <path
                                        d="M13.3163079,9.92245372 C13.3555125,8.12293916 11.7856724,6.57742174 9.96790469,6.59288244 C8.19210248,6.6072388 6.67140619,8.12956517 6.66642455,9.92742323 C6.661467,11.7401898 8.19541555,13.2846029 9.99993098,13.2823966 C11.8011333,13.2807377 13.3698691,11.7468158 13.3163079,9.92245372 M8.74759285,0 L11.1418336,0 C11.4378007,0.184976182 11.5979321,0.456090527 11.6807587,0.792360661 C11.7674505,1.14574799 11.9032861,1.48864414 11.9728605,1.84479231 C12.0225564,2.1015503 12.1512138,2.2451139 12.3770543,2.33787808 C12.9043836,2.55543215 13.428952,2.77850791 13.9579379,3.00103149 C14.4455105,2.72715631 14.9253525,2.45162462 15.4107164,2.18603196 C15.7718403,1.98890808 16.1246816,2.0330815 16.4195443,2.31026969 C16.8248425,2.69071324 17.2185449,3.08496099 17.595682,3.49301292 C17.8529966,3.77185761 17.9054534,4.10978425 17.7298611,4.46151508 C17.6602867,4.60121351 17.5807732,4.73594243 17.5034684,4.87232786 C17.2991628,5.23344554 17.094305,5.59401105 16.8971777,5.94077237 C17.1208095,6.48244889 17.3333978,6.99486053 17.5437773,7.50948083 C17.6415127,7.74801728 17.7812135,7.90428074 18.062824,7.95508017 C18.417874,8.01968379 18.7624326,8.14557803 19.1097521,8.25269857 C19.7348168,8.44374859 19.9567921,8.71762378 19.9860575,9.37470335 C20.0042794,9.79158997 20.0053837,10.2106853 19.9849532,10.628124 C19.9540312,11.2410302 19.7563518,11.4823275 19.1600003,11.6706167 C18.6840234,11.8208063 18.203077,11.9571917 17.7160566,12.1013075 C17.4476985,12.7329874 17.1837577,13.3547282 16.9181604,13.9803342 C16.9932565,14.1255543 17.0589656,14.2674614 17.1368226,14.4027425 C17.318489,14.7196868 17.5156163,15.026692 17.6867912,15.3486058 C17.8767402,15.7069626 17.9490754,16.0940322 17.6553171,16.4209155 C17.2616147,16.8598888 16.8380947,17.2745668 16.4073964,17.6776492 C16.14456,17.9228116 15.8259537,17.9741632 15.4929908,17.7941566 C15.1881889,17.6290584 14.8773131,17.4738993 14.5769287,17.2999665 C14.3676535,17.1801461 14.1677653,17.044865 13.9375073,16.9703223 C13.4333695,17.1834591 12.9446925,17.4076392 12.4433155,17.5970327 C12.173853,17.6991837 12.0253173,17.8399865 11.9678909,18.1403657 C11.8894817,18.5473133 11.7580635,18.9470827 11.6189148,19.3391218 C11.4438746,19.8327597 11.2031253,19.9901275 10.6802134,19.9956492 C10.2119671,20.0011709 9.74372071,20.0017231 9.27602653,19.9956492 C8.73268406,19.988471 8.48199557,19.810673 8.31744673,19.2955006 C8.1965199,18.915057 8.09215839,18.5290918 7.99773607,18.1414701 C7.93589221,17.8858164 7.81110014,17.7096749 7.55930729,17.6102847 C7.0286649,17.4015653 6.50520082,17.1762809 5.97676714,16.9570703 C5.49913377,17.2270803 5.03751355,17.5015077 4.56374542,17.7521918 C4.11372092,17.9896239 3.85254105,17.9493157 3.48479097,17.5953762 C3.10986258,17.2337063 2.74652991,16.8593366 2.38043636,16.4877278 C2.10766077,16.2110917 2.04747344,15.8875215 2.20650051,15.5330298 C2.28435751,15.359097 2.3843016,15.1951032 2.47541085,15.026692 C2.62449873,14.7517125 2.77027353,14.4745243 2.92543536,14.20341 C3.01047066,14.0543247 3.01488808,13.9168349 2.94752245,13.7578106 C2.71119056,13.2001212 2.48590222,12.6374623 2.26392695,12.0968902 C1.76199778,11.9494614 1.30148191,11.7976153 0.833235552,11.68166 C0.432907006,11.582822 0.156266177,11.3625071 0,10.9842722 L0,8.99646847 C0.157922709,8.56798633 0.474320304,8.34325407 0.910540375,8.24331172 C1.26393385,8.16269523 1.60462725,8.02686197 1.9585729,7.95176717 C2.15293931,7.90980242 2.26668783,7.81979908 2.33902306,7.64807493 C2.53394165,7.18370188 2.72168193,6.71601583 2.9293006,6.25771664 C3.03587082,6.02359753 2.99942712,5.83972568 2.86469585,5.62769328 C2.64161622,5.27651462 2.45332376,4.90324925 2.25343558,4.53771423 C2.02207329,4.1158581 2.10489988,3.7276842 2.41577571,3.39141406 C2.73327766,3.04741358 3.06292751,2.71114345 3.40914268,2.39640785 C3.8635846,1.98283424 4.19875622,1.96903005 4.72498119,2.27990047 C5.14132288,2.52616727 5.56373852,2.76304721 5.98449762,3.00489667 C6.3036561,2.86795908 6.60569709,2.73875183 6.90829025,2.60954459 C7.22468785,2.4742635 7.54108544,2.33843024 7.86687005,2.19928398 C7.95411407,1.89062223 8.0336276,1.5885865 8.12528903,1.2909681 C8.26664642,0.829355898 8.36051656,0.343448315 8.74759285,0"
                                        id="Fill-1"
                                    ></path>
                                </g>
                            </g>
                        </svg>
                    </g>
                    <g id="app-icon-team">
                        <svg
                            width="20px"
                            height="20px"
                            viewBox="0 0 20 20"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                        >
                            <title>icone mockup-06</title>
                            <g
                                id="Symbols"
                                stroke="none"
                                strokeWidth="1"
                                fillRule="evenodd"
                            >
                                <g
                                    id="Icon-/-Sidebar-/-passive-/-teams"
                                    fillRule="nonzero"
                                >
                                    <g
                                        id="icone-mockup-06"
                                        transform="translate(0.000000, -0.000000)"
                                    >
                                        <circle
                                            id="Oval"
                                            cx="10"
                                            cy="4.392"
                                            r="4.392"
                                        ></circle>
                                        <circle
                                            id="Oval"
                                            cx="4.392"
                                            cy="15.608"
                                            r="4.392"
                                        ></circle>
                                        <circle
                                            id="Oval"
                                            cx="15.608"
                                            cy="15.608"
                                            r="4.392"
                                        ></circle>
                                    </g>
                                </g>
                            </g>
                        </svg>
                    </g>
                </defs>
            </svg>
        </Fragment>
    );
}

export default App;
